const expandSeoText = () => {
  const expandBttn = document.getElementById('expand-btn');
  if (expandBttn) {
    const content = document.querySelector('.collection__seo-text .content>p');
    const button = document.getElementById('expand-btn').querySelector('span');
    expandBttn.addEventListener('click', function () {
      if (content.style.display === 'block') {
        content.style.display = '-webkit-box';
        content.style.webkitLineClamp = '3';
        button.textContent = 'ROZWIŃ TEKST';
      } else {
        content.style.display = 'block';
        content.style.webkitLineClamp = 'unset';
        button.textContent = 'ZWIŃ TEKST';
      }
    });
  }
};

const getFacetsDrawer = () => document.querySelector('.facets-drawer');

const updateActiveFilters = (facetsDrawer) => {
  if (window.innerWidth < 1000) {
    if (facetsDrawer) {
      const accordions = facetsDrawer.querySelectorAll('.accordion');

      accordions.forEach((accordion) => accordion.classList.remove('has-active-filter'));

      const checkedInputs = facetsDrawer.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked, input[type="number"]');

      checkedInputs.forEach((input) => {
        let isActive = false;

        if (input.type === 'number') {
          isActive = input.value !== input.placeholder && input.value !== '';
        } else {
          isActive = input.checked;
        }

        if (isActive) {
          const accordion = input.closest('.accordion');
          if (accordion) {
            accordion.classList.add('has-active-filter');
          }
        }
      });
    }
  }
};

const clearFilters = (facetsDrawer) => {
  const activeFiltersWrapper = facetsDrawer.querySelector('.facets-drawer__active-facets');
  const activeFacetsLists = facetsDrawer.querySelector('.active-facets');
  const removableFilters = facetsDrawer.querySelectorAll('.removable-facet a');
  const clearAll = facetsDrawer.querySelector('[data-clear-all]');
  const form = facetsDrawer.querySelector('form[is="facets-form"]');
  removableFilters.forEach((filter) => {
    filter.addEventListener('click', (e) => {
      e.preventDefault();
      const filterType = e.target.getAttribute('data-filter-type');
      const value = e.target.getAttribute('data-filter-value');
      const input = facetsDrawer.querySelector(`input[name='${filterType}'][value='${value}']`);

      if (filterType !== 'filter.v.price') {
        if (input?.checked) input.click();
      } else {
        const inputs = facetsDrawer.querySelectorAll('input[type="number"]');
        inputs.forEach((input) => {
          input.value = '';
          form.dispatchEvent(new Event('change', { cancelable: true }));
        });

        const minRangeInput = facetsDrawer.querySelector('input[type="range"][data-range-min]');
        const maxRangeInput = facetsDrawer.querySelector('input[type="range"][data-range-max]');
        if (minRangeInput) {
          minRangeInput.value = minRangeInput.min;
        }
        if (maxRangeInput) {
          maxRangeInput.value = maxRangeInput.max;
        }
        const parent = minRangeInput.parentNode;
        parent.style.setProperty('--range-min', '0%');
        parent.style.setProperty('--range-max', '100%');
      }

      e.target.parentNode.remove();
      updateActiveFilters(facetsDrawer);

      if (activeFacetsLists && activeFacetsLists.children.length <= 0) {
        activeFiltersWrapper.remove();
      }
    });
  });

  clearAll?.addEventListener('click', (e) => {
    e.preventDefault();
    const inputs = facetsDrawer.querySelectorAll('input:checked');
    inputs.forEach((input) => {
      input.click();
      activeFiltersWrapper?.remove();
      updateActiveFilters(facetsDrawer);
    });
  });
};

const initializeMutationObserver = () => {
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        const addedNodes = Array.from(mutation.addedNodes);
        const facetsDrawer = addedNodes.find((node) => node.matches && node.matches('facets-drawer'));
        if (facetsDrawer) {
          updateActiveFilters(facetsDrawer);
          clearFilters(facetsDrawer);
          showMore(facetsDrawer);
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
};
const showMore = (container) => {
  const showMoreBttns = container.querySelectorAll('.facets-show-more');

  if (showMoreBttns) {
    showMoreBttns.forEach((btn) => {
      const filtersWrapper = btn.parentElement.querySelector('.filters-custom-checkbox-wrapper');
      const hiddenFilters = filtersWrapper.querySelectorAll('.checkbox-control--filters.hidden');
      const btnText = btn.querySelector('span');
      let defaultHeight = `${filtersWrapper.offsetHeight}px`;
      filtersWrapper.style.height = defaultHeight;

      btn.addEventListener('click', () => {
        if (filtersWrapper.classList.contains('active')) {
          const expandedHeight = filtersWrapper.scrollHeight;
          filtersWrapper.style.height = `${expandedHeight}px`;
          filtersWrapper.offsetHeight;

          setTimeout(() => {
            filtersWrapper.style.height = defaultHeight;
          }, 10);
          setTimeout(() => {
            hiddenFilters.forEach((filter) => filter.classList.add('hidden'));
          }, 310);

          btnText.textContent = 'Pokaż więcej';
          btn.classList.remove('facets-show-more--active');
          filtersWrapper.classList.remove('active');
        } else {
          hiddenFilters.forEach((filter) => filter.classList.remove('hidden'));

          const expandedHeight = filtersWrapper.scrollHeight;
          filtersWrapper.style.height = `${expandedHeight}px`;
          btnText.textContent = 'Pokaż mniej';
          btn.classList.add('facets-show-more--active');
          filtersWrapper.classList.add('active');

          setTimeout(() => {
            filtersWrapper.style.height = 'auto';
          }, 300);
        }
      });
    });
  }
};

const toolbarShadow = () => {
  const toolbar = document.querySelector('.collection-toolbar');
  const intercept = document.createElement('div');

  intercept.setAttribute('data-observer-intercept', '');
  toolbar.before(intercept);

  const observer = new IntersectionObserver(([entry]) => {
    toolbar.classList.toggle('active', !entry.isIntersecting);
  });

  observer.observe(intercept);
};

document.addEventListener('DOMContentLoaded', () => {
  expandSeoText();
  initializeMutationObserver();
  toolbarShadow();
  if (window.innerWidth >= 1000) {
    const mainCollection = document.querySelector('.shopify-section--main-collection');
    showMore(mainCollection);
  }
});
